// extracted by mini-css-extract-plugin
module.exports = {"root":"home-overlay-module--root--2bnDk","toggled":"home-overlay-module--toggled--3DjMQ","inner":"home-overlay-module--inner--2DZ07"};